<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Usuários Administradores
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie todos os administradores do sistema. Utilize a busca e os filtros para encontrar e atualizar informações de forma eficiente.
        </p>
      </div>
    </div>

    <form #adminForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-weight: bold">Nome</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  [(ngModel)]="filters.nome"
                  name="nome"
                  placeholder="Digite o nome do administrador"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="login" style="font-weight: bold">Usuário/Login</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="login"
                  class="form-control"
                  [(ngModel)]="filters.login"
                  name="login"
                  placeholder="Digite o login do usuário"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="data_cadastro" style="font-weight: bold">Período de Cadastro</label>
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="text"
                  id="data_cadastro"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.periodoCadastroInicio"
                  name="data_cadastro_inicio"
                  placeholder="12/04/1990"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="text"
                  id="data_cadastro_fim"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.periodoCadastroFim"
                  name="data_cadastro_fim"
                  placeholder="12/04/1990"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto d-flex">
        <button
          type="button"
          class="btn btn-outline-primary mr-2"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
        <button
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0"
          (click)="applyFilters()"
        >
          <i class="fa fa-search mr-1"></i> Pesquisar
        </button>
      </div>
    </div>

    <hr class="my-3">

    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="openModal(cadastroAdministrador, null)"
        >
          <i class="fa fa-plus mr-2"></i>Adicionar Usuário
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="administradores.length > 0">
  <table class="table text-center" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('login')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Login
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('login')"
                class="fa"
                [ngClass]="getSortIcon('login')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let administrador of administradores| slice: (pageAd-1) * pageSizeAd : (pageAd-1) * pageSizeAd + pageSizeAd">
        <td class="pl-3 pr-3 align-middle">
          <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
            {{ administrador.nome }}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ administrador.login }}
        </td>
        <td class="d-flex justify-content-end">
          <button type="button" (click)="openModal(atualizarSenha, administrador)" class="btn btn-outline-primary mr-1">
            Alterar Senha
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  
  <!-- Paginação dos administradores -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      *ngIf="administradores.length > 0"
      [(page)]="pageAd"
      [pageSize]="pageSizeAd"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="administradores.length"
    ></ngb-pagination>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="administradores.length == 0">
  <div class="card-body">
    <div class="text-center">
      <h5 class="mt-0">Nenhum usuário administrador encontrado.</h5>
      <p class="text-muted">Ajuste os filtros ou cadastre um novo administrador.</p>
    </div>
  </div>
</div>

<ng-template #cadastroAdministrador let-modal>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Novo Administrador</h4>
    </div>
    <div class="card-content">
      <div class="card-body">
        <form #cadForm="ngForm" class="editForm" novalidate>
          <div class="form-row">
            <div class="col-12">
              <div class="form-group mb-2">
                <label for="nome">Nome</label>
                <input type="text" id="nome" class="form-control" name="nome" [(ngModel)]="novoAdministrador.nome" #inputName="ngModel" required>
              </div>
              <div class="form-group mb-2">
                <label for="login">Login</label>
                <input type="text" id="login" class="form-control" name="login" [(ngModel)]="novoAdministrador.login" #inputLog="ngModel" required>
              </div>
              <div class="form-group mb-2">
                <label for="novaSenha">Nova Senha</label>
                <input type="password" id="novaSenha" class="form-control" name="novaSenha" [(ngModel)]="novoAdministrador.senha" #inputSenh="ngModel" required>
              </div>
              <div class="form-group mb-2">
                <label for="confirmaNovaSenha">Confirme a Nova Senha</label>
                <input type="password" id="confirmaNovaSenha" class="form-control" name="confirmaNovaSenha" [(ngModel)]="novoAdministrador.confirmaSenha" #inputConfir="ngModel" required>
              </div>
              <div class="form-row mt-4">
                <div class="col-6 text-center">
                  <button type="button" class="btn btn-lg btn-block btn-secondary" (click)="modal.close('Close click')">Cancelar</button>
                </div>
                <div class="col-6 text-center">
                  <button type="button" class="btn btn-lg gradient-mint btn-block" (click)="insertAdministrador(modal)" [disabled]="!novoAdministrador || !novoAdministrador.nome || !novoAdministrador.login || !novoAdministrador.senha || !novoAdministrador.confirmaSenha || (novoAdministrador.senha!=novoAdministrador.confirmaSenha)">Cadastrar</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<ng-template #atualizarSenha let-modal>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Nova Senha</h4>
    </div>
    <div class="card-content">
      <div class="card-body">
        <form #exForm="ngForm" class="editForm" novalidate>
          <div class="form-row">
            <div class="col-12">
              <div class="form-group mb-2">
                <label for="novaSenha">Nova Senha</label>
                <input type="password" id="novaSenha" class="form-control" name="novaSenha" [(ngModel)]="atualizacaoSenha.novaSenha" #inputSenha="ngModel" required>
              </div>
              <div class="form-group mb-2">
                <label for="confirmaNovaSenha">Confirme a Nova Senha</label>
                <input type="password" id="confirmaNovaSenha" class="form-control" name="confirmaNovaSenha" [(ngModel)]="atualizacaoSenha.confirmaNovaSenha" #inputConfir="ngModel" required>
              </div>
              <div class="form-row mt-4">
                <div class="col-6 text-center">
                  <button type="button" class="btn btn-lg btn-block btn-secondary" (click)="modal.close('Close click')">Cancelar</button>
                </div>
                <div class="col-6 text-center">
                  <button type="button" class="btn btn-lg gradient-mint btn-block" (click)="updateSenha(modal)" [disabled]="!atualizacaoSenha || !atualizacaoSenha.novaSenha || !atualizacaoSenha.confirmaNovaSenha || (atualizacaoSenha.novaSenha!=atualizacaoSenha.confirmaNovaSenha)">Atualizar</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>
<ngx-spinner></ngx-spinner> 